import React from "react";
import { CheckCircle, Paperclip, Trash } from "@phosphor-icons/react";
import { ActionButton, ActionGroup, StatusBadge } from "../app";
import { Button } from "../ui/button";

export function createPurchaseOrderColumns({
  isSpanish,
  poStatusLabel,
  invoiceStatusLabel,
  invoiceStatusTone,
  onDownloadInvoice,
  onOpenInvoiceDialog,
  onOpenCancelDialog,
  onDeletePurchaseOrder,
}) {
  return [
    {
      id: "po_number",
      header: "# OC",
      cellClassName: "text-[#E2B05E] font-mono text-sm",
      mobileClassName: "text-[#E2B05E] font-mono text-sm",
      render: (po) => po.po_number,
      hideOnMobile: true,
    },
    {
      id: "supplier",
      header: isSpanish ? "Proveedor" : "Supplier",
      cellClassName: "text-[#F3F4F6]",
      render: (po) => po.supplier_name,
      hideOnMobile: true,
    },
    {
      id: "description",
      header: isSpanish ? "Descripcion" : "Description",
      cellClassName: "text-[#9CA3AF] text-sm max-w-[220px] truncate",
      mobileClassName: "text-[#9CA3AF]",
      render: (po) => po.description,
    },
    {
      id: "total",
      header: "Total",
      align: "right",
      cellClassName: "text-[#F3F4F6] font-semibold",
      mobileClassName: "font-semibold text-[#F3F4F6]",
      render: (po) => `$${po.total?.toLocaleString()}`,
    },
    {
      id: "status",
      header: isSpanish ? "Estado" : "Status",
      render: (po) => (
        <div className="flex flex-col gap-1">
          <StatusBadge
            value={po.status}
            label={poStatusLabel(po.status)}
            tone={po.status === "cancelada" ? "success" : "warning"}
            statusContext="purchase_order"
          />
          {po.bank_transfer_number ? (
            <span className="text-xs text-[#9CA3AF] font-mono">
              {po.bank_transfer_number}
            </span>
          ) : null}
        </div>
      ),
      hideOnMobile: true,
    },
    {
      id: "invoice",
      header: isSpanish ? "Factura" : "Invoice",
      mobileHeader: isSpanish ? "Factura" : "Invoice",
      render: (po) => (
        <div className="flex items-center gap-2">
          <StatusBadge
            value={po.invoice_status}
            label={invoiceStatusLabel(po)}
            tone={invoiceStatusTone(po)}
          />
          {po.invoice_attachment ? (
            <Button
              size="sm"
              variant="ghost"
              onClick={() => onDownloadInvoice(po)}
              className="text-[#9CA3AF] hover:text-[#F3F4F6]"
            >
              <Paperclip className="w-4 h-4" />
            </Button>
          ) : null}
        </div>
      ),
    },
    {
      id: "actions",
      header: isSpanish ? "Acciones" : "Actions",
      actions: true,
      render: (po) => (
        <ActionGroup className="gap-1">
          {po.status !== "cancelada" ? (
            <ActionButton
              icon={Paperclip}
              tone="default"
              iconOnly
              onClick={() => onOpenInvoiceDialog(po)}
              title={
                po.invoice_attachment
                  ? isSpanish
                    ? "Reemplazar factura"
                    : "Replace invoice"
                  : isSpanish
                    ? "Agregar factura"
                    : "Add invoice"
              }
            />
          ) : null}
          {po.status !== "cancelada" ? (
            <ActionButton
              icon={CheckCircle}
              tone="approve"
              iconOnly
              onClick={() => onOpenCancelDialog(po)}
              title={isSpanish ? "Marcar como pagada" : "Mark as paid"}
            />
          ) : null}
          <ActionButton
            icon={Trash}
            tone="delete"
            iconOnly
            onClick={() => onDeletePurchaseOrder(po)}
            title={isSpanish ? "Eliminar orden" : "Delete order"}
          />
        </ActionGroup>
      ),
    },
  ];
}
